import { useContext } from "react"
import { MdArrowForward } from "react-icons/md"
import { AppContext } from "../App"
import { formatDate, formatMoney } from "../Helpers"


export default function OrderCard({ data }) {

  const appContext = useContext(AppContext);

  function viewOrder() {
    appContext.navTo({
      item: 'view',
      subItem: 'view-order',
      extraItem: data.uuid,
    })
  }

  return (
    <div className="card customer-order-card" onClick={viewOrder}>
      <div className="card-body">
        <div className="customer-order-main">
          <div>
            <div className="d-flex align-items-center flex-wrap gap-2 mb-2">
              <span className="library-type-badge">{data.itemType}</span>
              <span className={`order-status-badge ${data.status}`}>{data.status}</span>
            </div>
            <h6>{data.item?.title || 'Content is unavailable'}</h6>
            <p>{formatDate(data.dateCreated)} · {data.payPhone}</p>
          </div>

          <div className="customer-order-action">
            <h6>TZS {formatMoney(data.amount)}</h6>
            <MdArrowForward size={23}/>
          </div>
        </div>
      </div>
    </div>
  )
}
